import { useQuery } from '@tanstack/react-query';
import { getFileDetail } from '../api/filesApi';

export const fileDetailKeys = {
  all: ['files'] as const,
  detail: (fileId: string) =>
    [...fileDetailKeys.all, fileId, 'detail'] as const,
};

export function useFileDetail(fileId: string | null) {
  return useQuery({
    queryKey: fileDetailKeys.detail(fileId!),
    queryFn: () => getFileDetail(fileId!),
    enabled: !!fileId,
  });
}
